var __jsx = React.createElement;
import { FormHelperText, InputAdornment } from '@material-ui/core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextFieldWithStatus } from 'components/common/material-ui/custom-components';
import { useCharactersCount, useFieldError } from 'libs/content/hooks';

var Input = function Input(_ref) {
  var name = _ref.name,
      type = _ref.type,
      label = _ref.label,
      _ref$multiline = _ref.multiline,
      multiline = _ref$multiline === void 0 ? false : _ref$multiline,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 0 : _ref$rows,
      _ref$displayCharacter = _ref.displayCharactersCount,
      displayCharactersCount = _ref$displayCharacter === void 0 ? false : _ref$displayCharacter,
      minCharactersCount = _ref.minCharactersCount,
      maxCharactersCount = _ref.maxCharactersCount,
      recommendedCharactersCount = _ref.recommendedCharactersCount,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      watch = _useFormContext.watch;

  var inputValue = watch(name);
  var errorMessage = useFieldError(name);

  var _useCharactersCount = useCharactersCount({
    inputText: inputValue !== null && inputValue !== void 0 ? inputValue : '',
    displayCharactersCount: displayCharactersCount,
    minCharactersCount: minCharactersCount,
    maxCharactersCount: maxCharactersCount,
    recommendedCharactersCount: recommendedCharactersCount
  }),
      ratio = _useCharactersCount.ratio,
      helperText = _useCharactersCount.helperText,
      status = _useCharactersCount.status;

  if (rows <= 0) {
    rows = multiline ? '3' : '';
  } else {
    rows = rows.toString();
  }

  return __jsx(React.Fragment, null, __jsx(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '',
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          onChange = _ref2$field.onChange,
          value = _ref2$field.value;
      return __jsx(TextFieldWithStatus, {
        type: type,
        id: "form-field-".concat(name),
        value: value,
        variant: "outlined",
        error: Boolean(errorMessage),
        label: label,
        fullWidth: true,
        multiline: multiline,
        rows: rows,
        helperText: errorMessage,
        onChange: onChange,
        status: status,
        InputProps: {
          endAdornment: __jsx(InputAdornment, {
            position: "end"
          }, ratio),
          disabled: disabled !== null && disabled !== void 0 ? disabled : false
        }
      });
    }
  }), __jsx(FormHelperText, {
    variant: "outlined"
  }, helperText));
};

export default Input;